var _BUTTON_PROGRESS_STYL;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Icon from '../icon/Icon';
import { STYLE_LIGHT, STYLE_DARK } from '../progressIndicator/constants';
export var TYPE_BUTTON = 'button';
export var TYPE_SUBMIT = 'submit';
export var TYPE_LINK = 'link';
export var TYPES = [TYPE_BUTTON, TYPE_SUBMIT, TYPE_LINK];
export var STYLE_NONE = 'none';
export var STYLE_ANCHOR = 'anchor'; // new styles

export var STYLE_LINK = 'link';
export var STYLE_DANGER = 'danger';
export var STYLE_NEUTRAL = 'neutral';
export var STYLE_FILL = 'fill';
export var STYLE_INVERSE = 'inverse';
export var STYLE_FOLLOW = 'follow'; // Patch button styles so we don't break things

export var STYLES = [STYLE_NONE, STYLE_LINK, STYLE_DANGER, STYLE_NEUTRAL, STYLE_FILL, STYLE_INVERSE, STYLE_ANCHOR, STYLE_FOLLOW];
export var BUTTON_PROGRESS_STYLE = (_BUTTON_PROGRESS_STYL = {}, _defineProperty(_BUTTON_PROGRESS_STYL, STYLE_NONE, STYLE_DARK), _defineProperty(_BUTTON_PROGRESS_STYL, STYLE_LINK, STYLE_DARK), _defineProperty(_BUTTON_PROGRESS_STYL, STYLE_DANGER, STYLE_DARK), _defineProperty(_BUTTON_PROGRESS_STYL, STYLE_NEUTRAL, STYLE_DARK), _defineProperty(_BUTTON_PROGRESS_STYL, STYLE_FILL, STYLE_LIGHT), _defineProperty(_BUTTON_PROGRESS_STYL, STYLE_INVERSE, STYLE_LIGHT), _defineProperty(_BUTTON_PROGRESS_STYL, STYLE_ANCHOR, STYLE_DARK), _BUTTON_PROGRESS_STYL);
export var SIZE_RESPONSIVE = 'responsive';
export var SIZE_BLOCK = 'block';
export var SIZES = [SIZE_RESPONSIVE, SIZE_BLOCK];
export var CHILD_COMPONENT_WHITELIST = [Icon];